import { render, staticRenderFns } from "./AllocationUser.vue?vue&type=template&id=294c1216&scoped=true&"
import script from "./AllocationUser.vue?vue&type=script&lang=js&"
export * from "./AllocationUser.vue?vue&type=script&lang=js&"
import style0 from "./AllocationUser.vue?vue&type=style&index=0&id=294c1216&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294c1216",
  null
  
)

export default component.exports